import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceNotificationsStore } from '../entry-maintenance-notifications.store';
import { EntryMaintenanceNotificationDetailsComponent } from './entry-maintenance-notification-details.component';
import { EntryMaintenanceNotificationAddComponent } from './entry-maintenance-notification-add.component';

@Component({
  selector: 'app-entry-maintenance-notification',
  standalone: true,
  imports: [
    CommonModule,
    EntryMaintenanceNotificationDetailsComponent,
    EntryMaintenanceNotificationAddComponent,
  ],
  template: `
    @let maintenance = store.maintenanceNotification();

    @if (maintenance) {
      <app-entry-maintenance-notification-details />
    } @else {
      <app-entry-maintenance-notification-add />
    }
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
    }
    app-entry-maintenance-notification-add,
    app-entry-maintenance-notification-details {
      flex: 1 1 auto;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  `,
})
export class EntryMaintenanceNotificationComponent implements OnDestroy {
  store = inject(MaintenanceNotificationsStore);

  ngOnDestroy(): void {
    this.store.clearSelectedMaintenanceNotification();
  }
}
